
import { defineComponent, computed, PropType } from 'vue'

import JrButton from '@/components/jr-parts/JrButton.vue'
import MessageTypeLogic from '@/services/messageTypeLogic'
import Logger from '@/services/logger'

type PageType = 'applicant' | 'discussion'

/**
 * 送信者へ連絡ボタン
 * 表示しているメッセージの申請基本ID、種別、メッセージIDを渡すと
 * 送信者へ連絡が可能な場合は送信画面に遷移するリンクを表示する
 */
export default defineComponent({
  name: 'PushSenderQuestion',
  components: {
    JrButton,
  },
  props: {
    // JRか協議者側か
    type: {
      type: String as PropType<PageType>,
      required: true,
    },
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: false,
      default: null,
    },
    // メッセージ種別
    messageType: {
      type: Number,
      required: false,
      default: null,
    },
    // 元メッセージID
    messageId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const to = computed(() => {
      if (props.requestHeaderId == null || props.messageType == null || props.messageId == null) {
        // 情報が無い場合はnull
        return null
      }
      const logic = new MessageTypeLogic(props.messageType, props.requestHeaderId)
      const replyType = logic.getReplyType()
      if (replyType == null) {
        // 返信できない種別ならnull
        return null
      }

      if (props.type === 'applicant') {
        // 申請者側受信画面
        return {
          name: 'ApplicantNormalMessage',
          params: {
            request_header_id: props.requestHeaderId,
            message_type: replyType,
            action: 'reply',
            message_id: props.messageId,
          },
        }
      } else if (props.type === 'discussion') {
        // JR側が送信者質問できるかどうか
        if (logic.canJrSenderQuestion(replyType)) {
          // JR側受信画面
          return {
            name: 'NormalMessage',
            params: {
              request_header_id: props.requestHeaderId,
              message_type: replyType,
              action: 'reply',
              message_id: props.messageId,
            },
          }
        } else {
          return null
        }
      }
      Logger.warn(`ページ種別が異なります。type: ${props.type}`)
      return null
    })

    // 申請者側の画面の場合は表示を変更する
    const buttonName = computed(() => {
      let name = '送信者へ連絡'
      if (props.type === 'applicant') {
        name = 'お問合せはこちら'
      }
      return name
    })

    // 申請者側の画面の場合はクラスのタイプを変更する
    const buttonClass = computed(() => {
      let buttonClass = 'primary'
      if (props.type === 'applicant') {
        buttonClass = 'text'
      }
      return buttonClass
    })

    // 申請者側の画面の場合は表示を変更する
    const buttonQuestionApplicant = computed(() => {
      let buttonColor = null
      if (props.type === 'applicant') {
        buttonColor = 'button-question-applicant'
      }
      return buttonColor
    })

    return { to, buttonName, buttonClass, buttonQuestionApplicant }
  },
})
